import { CircularProgress, InputAdornment, TextField } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import FormBuilderService from "../../services/form-builder.service";
import { formNameExistState } from "../../services/form.store";

const formBuilderService = new FormBuilderService();

const FormNameControl = ({
  formTitle,
  setFormTitle,
  helperText,
  error,
  setDisableActionBtn,
  updateFormNameState = () => {},
  updateForm,
}) => {
  const [titleLoading, setTitleLoading] = useState(true);
  const [formNameExistError, setFormNameExistError] = useState(false);
  const [editFormTitle, setEditFormTitle] = useState("");
  const timeoutIdRef = useRef(null);

  useEffect(() => {
    if (formTitle?.length && !updateForm) {
      formBuilderService.isValidName(formTitle).then((res) => {
        setFormNameExistError(res.data);
        setTitleLoading(false);
      });
    } else {
      setEditFormTitle(formTitle);
      setTitleLoading(false);
    }

    return () => {
      if (timeoutIdRef.current) clearTimeout(timeoutIdRef.current);
      formNameExistState.next(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!formTitle) {
      setFormNameExistError(false);
      setTitleLoading(false);
    }
  }, [formTitle]);

  useEffect(() => {
    setDisableActionBtn(error || formNameExistError || titleLoading);
    formNameExistState.next(!!formNameExistError);
  }, [error, formNameExistError, setDisableActionBtn, titleLoading]);

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value.trimStart();
    setTitleLoading(true);
    setFormTitle(value);
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
    }
    timeoutIdRef.current = setTimeout(() => {
      if (value) {
        if (updateForm && value === editFormTitle) {
          setFormNameExistError(false);
          setTitleLoading(false);
        } else {
          formBuilderService.isValidName(value).then((res) => {
            if (!res.data) {
              updateFormNameState(name, value);
            }
            setFormNameExistError(res.data);
            setTitleLoading(false);
          });
        }
      } else {
        setFormNameExistError(false);
        setTitleLoading(false);
      }
    }, 1000);
  };

  return (
    <TextField
      fullWidth
      id="title"
      error={formNameExistError || error}
      helperText={formNameExistError ? "Form Name Already Exist!" : helperText}
      label="Form Name"
      name="title"
      value={formTitle}
      onChange={handleChange}
      required
      variant="outlined"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {titleLoading && <CircularProgress size={20} />}
          </InputAdornment>
        ),
      }}
    />
  );
};

export default FormNameControl;
